import React from "react";
import { Card, Avatar, Typography } from "antd";

const stringToColor = (str) => {
  if (!str) return "#667085";
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  return `hsl(${hash % 360}, 65%, 55%)`;
};

const getInitial = (name) => name?.trim()?.charAt(0)?.toUpperCase() || "?";

export const buildPartnersDropdown = (partners, activeUsers = []) => (
  <Card
    style={{
      borderRadius: 16,
      boxShadow: "0 12px 40px rgba(15,23,42,0.15)",
      minWidth: 320,
    }}
    bodyStyle={{ padding: 16 }}
  >
    <Typography.Text
      strong
      style={{
        display: "block",
        marginBottom: 10,
        fontWeight: 900,
        fontSize: 16,
      }}
    >
      Partners
    </Typography.Text>

    {partners.map((item, index) => {
      const { name, specialization, hospital } = item;
      return (
        <div
          key={index}
          style={{
            display: "flex",
            alignItems: "center",
            gap: 12,
            padding: "8px 0",
          }}
        >
          <div style={{ position: "relative", display: "inline-flex" }}>
            <Avatar
              size={28}
              style={{
                backgroundColor: stringToColor(name),
                fontWeight: 900,
                fontSize: 14,
              }}
            >
              {getInitial(name)}
            </Avatar>
            <span
              style={{
                position: "absolute",
                bottom: 0,
                right: 0,
                width: 9,
                height: 9,
                backgroundColor: "#16a34a",
                borderRadius: "50%",
                border: "1px solid white",
              }}
            />
          </div>
          <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
            <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
              <Typography.Text
                strong
                style={{ fontSize: 14, color: "#101828" }}
              >
                {name}
              </Typography.Text>
              {specialization && (
                <Typography.Text style={{ fontSize: 12, color: "#475467" }}>
                  {specialization}
                </Typography.Text>
              )}
            </div>
            {hospital && (
              <Typography.Text
                style={{ fontSize: 12, color: "#667085", marginTop: 2 }}
              >
                {hospital}
              </Typography.Text>
            )}
          </div>
        </div>
      );
    })}

    {activeUsers.length > 0 && (
      <>
        <div style={{ borderTop: "1px solid #F2F4F7", margin: "10px 0 8px" }} />
        <Typography.Text
          strong
          style={{
            display: "block",
            marginBottom: 10,
            fontWeight: 900,
            fontSize: 16,
          }}
        >
          Active Users
        </Typography.Text>
        {activeUsers.map((u, i) => {
          const fullName = `${u.first_name || ""} ${u.last_name || ""}`.trim();
          return (
            <div
              key={i}
              style={{
                display: "flex",
                alignItems: "center",
                gap: 12,
                padding: "6px 0",
              }}
            >
              <Avatar
                size={28}
                style={{
                  backgroundColor: stringToColor(fullName),
                  fontWeight: 900,
                  fontSize: 14,
                }}
              >
                {getInitial(fullName)}
              </Avatar>
              <Typography.Text style={{ fontSize: 14, fontWeight: 700 }}>
                {fullName || "User"}
              </Typography.Text>
            </div>
          );
        })}
      </>
    )}
  </Card>
);
